export default __webpack_public_path__ + "static/media/IMG_3619.dd203946.jpg";